wbApp.controller('GroupsDetailCtrl', ['$scope', 'groupSvc', 'tenantSettingSvc', 'messageBoxSvc',
function ($scope, groupSvc, tenantSettingSvc, messageBoxSvc) {

    $scope.childrenGroupModel = {
        capacity: $scope.model.groupType == 1 ? $scope.model.capacity : null,
        projectName: $scope.model.groupType == 1 ? $scope.model.projectName : null,
        projectRegistrationNumber: $scope.model.groupType == 1 ? $scope.model.projectRegistrationNumber : null,
        projectBeneficiary: $scope.model.groupType == 1 ? $scope.model.projectBeneficiary : null
    };

    

    $scope.nurseryGroupModel = {
        capacity: null,
        projectName: $scope.model.groupType == 2 ? $scope.model.projectName : null,
        projectRegistrationNumber: $scope.model.groupType == 2 ? $scope.model.projectRegistrationNumber : null,
        projectBeneficiary: $scope.model.groupType == 2 ? $scope.model.projectBeneficiary : null
    }

    $scope.detailIsUnchanged = function () {
        return angular.equals($scope.model, $scope.modelOrig) &&
            angular.equals($scope.nurseryGroupModel, $scope.nurseryGroupModelOrig) &&
            angular.equals($scope.childrenGroupModel, $scope.childrenGroupModelOrig);
    };

    $scope.detailTabs = [
        {
            title: 'TXT_MAIN',
            template: "users/groups/group-detail-main-tab.html"
        }];

    if (tenantSettingSvc.settings.childrenGroupSupport) {
        $scope.detailTabs.push({
            title: "TXT_LBL_CHILDREN_GROUP",
            template: "users/groups/group-detail-children-group.html"
        });
    } else {
        $scope.childrenGroupModel.capacity = null;
        $scope.childrenGroupModel.projectName = null;
        $scope.childrenGroupModel.projectRegistrationNumber = null;
        $scope.childrenGroupModel.projectBeneficiary = null;
    }

    if (tenantSettingSvc.settings.smallNurserySupport) {
        $scope.detailTabs.push({
            title: "TXT_LBL_SMALL_NURSERY",
            template: "users/groups/group-detail-nursery.html"
        });
    } else {
        $scope.nurseryGroupModel.capacity = null;
        $scope.nurseryGroupModel.projectName = null;
        $scope.nurseryGroupModel.projectRegistrationNumber = null;
        $scope.nurseryGroupModel.projectBeneficiary = null;
    }

    $scope.nurseryGroupModelOrig = angular.copy($scope.nurseryGroupModel);
    $scope.childrenGroupModelOrig = angular.copy($scope.childrenGroupModel);
    $scope.modelOrig = angular.copy($scope.model);

    $scope.isSaving = false;

    $scope.onDetailSave = function (model) {

        var isChildrenGroupModelSet = (!!($scope.childrenGroupModel.capacity) || ($scope.childrenGroupModel.capacity === 0)) ||
            !!($scope.childrenGroupModel.projectName) ||
            !!($scope.childrenGroupModel.projectRegistrationNumber) ||
            !!($scope.childrenGroupModel.projectBeneficiary);

        var isNurseryGroupModelSet = !_.isNil($scope.nurseryGroupModel.capacity) ||
            !!($scope.nurseryGroupModel.projectName) ||
            !!($scope.nurseryGroupModel.projectRegistrationNumber) ||
            !!($scope.nurseryGroupModel.projectBeneficiary);

        if (isChildrenGroupModelSet && isNurseryGroupModelSet) {
            messageBoxSvc.showMessageDlg({
                title: 'TXT_TITLE_INFORMATION',
                message: 'TXT_NURSERY_OR_CHILDREN_GROUP',
                buttons: [{
                    text: 'TXT_BTN_OK'
                }]
            });
            return;
        }

        var modelToSave = angular.copy(model);

        if (isChildrenGroupModelSet) {
            modelToSave.groupType = 1;
            modelToSave.capacity = $scope.childrenGroupModel.capacity;
            modelToSave.projectName = $scope.childrenGroupModel.projectName;
            modelToSave.projectRegistrationNumber = $scope.childrenGroupModel.projectRegistrationNumber;
            modelToSave.projectBeneficiary = $scope.childrenGroupModel.projectBeneficiary;
        } else if (isNurseryGroupModelSet) {
            modelToSave.groupType = 2;
            modelToSave.capacity = null;
            modelToSave.projectName = $scope.nurseryGroupModel.projectName;
            modelToSave.projectRegistrationNumber = $scope.nurseryGroupModel.projectRegistrationNumber;
            modelToSave.projectBeneficiary = $scope.nurseryGroupModel.projectBeneficiary;
        } else {
            modelToSave.groupType = 0;
            modelToSave.capacity = null;
            modelToSave.projectName = null;
            modelToSave.projectRegistrationNumber = null;
            modelToSave.projectBeneficiary = null;
        }

        $scope.isSaving = true;

        if (!modelToSave.groupID) {
            groupSvc.insert(modelToSave, success, error, $scope.collection);
        } else {
            groupSvc.update(modelToSave, success, error, $scope.collection);
        }

        function success() {
            $scope.isSaving = false;
            $scope.$hide();
        }

        function error(data) {
            $scope.isSaving = false;
            $scope.detailError = data;
        }
    }
}]);
